import {Pipe, PipeTransform} from "@angular/core";
import {formatMediaTypeKey} from './format-media-type';


@Pipe({
  standalone: true,
  name: 'mimeTypeKey'
})
export class MimeTypeKeyPipe implements PipeTransform {
  transform(mimeType: string): string {
    return formatMediaTypeKey(mimeType);
  }
}
